import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {
	allOption?: boolean;
}

export function ChannelsDropdown(props: Props) {
	const { allOption = true } = props;

	return (
		<FilterDropdown
			{...props}
			id="channelIds"
			allOption={allOption}
			values={props.options?.data ?? []}
			objectName="Channels"
			fullLength
			isMulti
		/>
	);
}
